"use client"

import React from 'react'
import SidebarLink from './sidebar-link';
import { getSidebarLinks } from '../../constants/content';
import Logo from '../logo';
import {
    Sidebar,
    SidebarContent,
    SidebarFooter,
    SidebarHeader,
    useSidebar,
} from "../ui/sidebar"
import { Button } from '../ui/button';
import { X } from 'lucide-react';
import { useSession } from '@/features/auth/context/session.context'
import { useIsGroupContact } from '@/features/stm/hooks/use-is-group-contact'
import { Skeleton } from '../ui/skeleton';
import { useNavLockedUntilProfileComplete } from '@/features/profile/hooks/use-nav-profile-lock'

function DashboardSideBar() {
    const { toggleSidebar } = useSidebar()
    const { session, isLoading } = useSession()
    const { isGroupContact, inAnyGroup } = useIsGroupContact()
    const navLocked = useNavLockedUntilProfileComplete()
    if(isLoading) {
        return (
            <Sidebar>
                <SidebarHeader className='h-nav px-0 border-b'>
                    <div className={`flex items-center px-dashboard  h-nav justify-between ml-2`}>
                        <Logo />
                        <Button variant={"ghost"} size={"icon"} className='rounded-full md:hidden' onClick={toggleSidebar}>
                            <X className='w-6 h-6' />
                        </Button>
                    </div>
                </SidebarHeader>
                <SidebarContent className='flex flex-col pt-5 px-dashboard gap-4'>
                    {[1, 2, 3, 4, 5, 6].map((num) => {
                        return (
                            <Skeleton key={num} className='h-10 w-full' />
                        )
                    })}
                </SidebarContent>
                <SidebarFooter />
            </Sidebar>
        )
    }

    if(!session) return null

    const sidebarLinks = getSidebarLinks(session?.role, isGroupContact || inAnyGroup) || []

    return (
        <Sidebar>
            <SidebarHeader className='h-nav px-0 border-b'>
                <div className={`flex items-center px-dashboard  h-nav justify-between ml-2`}>
                    <Logo />
                    <Button variant={"ghost"} size={"icon"} className='rounded-full md:hidden' onClick={toggleSidebar}>
                        <X className='w-6 h-6' />
                    </Button>
                </div>
            </SidebarHeader>
            <SidebarContent className='flex flex-col pt-5 px-dashboard gap-4'>
                {sidebarLinks.map(({ icon, ...link }) => {
                    return (
                        <SidebarLink 
                            key={link.name} 
                            icon={icon} 
                            {...link}
                            navLocked={navLocked}
                        />
                    )
                })}
            </SidebarContent>
            <SidebarFooter />
        </Sidebar>
    );
}


export default DashboardSideBar
